import styled from "styled-components";

const Container = styled.div`
    @media (max-width: 992px) {
        max-width: 960px;
    }
    @media (max-width: 768px) {
        max-width: 720px;
    }
    @media (max-width: 576px) {
        max-width: 540px;
    }
`;

export default Container;
